import React from 'react';
import { FirstbornFigure } from './FirstbornFigure';
import { MiddleChildFigure } from './MiddleChildFigure';
import { YoungestFigure } from './YoungestFigure';
import { OnlyChildFigure } from './OnlyChildFigure';
import type { SiblingRole } from '../../types/snak';
interface SiblingFigureProps {
  role: SiblingRole;
  className?: string;
}
export function SiblingFigure({
  role,
  className = ''
}: SiblingFigureProps) {
  if (role === 'firstborn') return <FirstbornFigure className={className} data-id="element-59" data-mp="2qj61kupj9x1q" />;
  if (role === 'middle') return <MiddleChildFigure className={className} data-id="element-60" data-mp="2ujpzi0hxl4ox" />;
  if (role === 'youngest') return <YoungestFigure className={className} data-id="element-61" data-mp="2zhhtd024z0vr" />;
  return <OnlyChildFigure className={className} data-id="element-62" data-mp="2zgoo63itsjfq" />;
}